import { render } from "./ControlsTabletFormComponentDetails.vue?vue&type=template&id=aa33d2c8"
import script from "./ControlsTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./ControlsTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__